export const toDemo = () => '/demo';
export const toHome = () => '/';
